import * as screens from "../map-screens"
import { Routes, Route, Navigate } from "react-router-dom";

const MapNavigation = () => {
  return (
    <Routes>
      <Route path="/" element={<screens.MainMapScreen />}/>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

export default MapNavigation